import { Card } from "@mui/material";
import styled from "styled-components";

const StyledCard = styled(Card)`
  padding: 1rem;
`;

export default StyledCard;
